import { default as details } from './details';
import { default as addressDetails } from './addressDetails';
import countryOfOrigin from './countryOfOrigin';
import obfuscation from './obfuscation';
import setupInsurant from './setupInsurant';
import setupInsurantAddress from './setupInsurantAddress';

export const insurant = {
  ...details,
  ...addressDetails,
  ...countryOfOrigin,
  ...obfuscation,
  ...setupInsurant,
  ...setupInsurantAddress,
};
